<div class="row mb-3">
  <div class="col-8 col-lg-10">
    <mat-label class="heading">{{ "editTechnicalTraining" | translate }}</mat-label>
  </div>
  <div class="col-4 col-lg-2">
    <div class="d-flex justify-content-end">
      <mat-icon (click)="closeNotif()">close</mat-icon>
    </div>
  </div>
</div>

<form [formGroup]="editTrainingsFormGroup">
  <div class="row mb-3">
    <div class="col-lg-12">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label>{{ "trainingVocationalCourse" | translate }}</mat-label>
        <input matInput formControlName="trainingCourse" appNoLeadingSpaces />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 mb-3">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label>{{ "hoursOfTraining" | translate }}</mat-label>
        <input matInput type="number" formControlName="hoursOfTraining" min="1" max="99999" maxlength="5"
          appNumericOnlyFive appNumericOnlyZeroNine />
      </mat-form-field>
    </div>
    <div class="col-lg-6 mb-3">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label>{{ "trainingInstitution" | translate}}</mat-label>
        <input matInput formControlName="trainingInstitution" appNoLeadingSpaces />
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-3">
    <div [class.col-lg-12]="othersCertificate !== 'Others'" [class.col-lg-6]="othersCertificate == 'Others'">
      <mat-form-field appearance="outline">
        <mat-label >{{ "certificatesReceived" | translate }}</mat-label>
        <mat-select formControlName="certificates" [(ngModel)]="othersCertificate">
          <mat-option *ngFor="let certifateType of certifateTypes" [value]="certifateType.name">{{ certifateType.name
            }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-lg-6" *ngIf="othersCertificate == 'Others'">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label>{{ "others" | translate }}</mat-label>
        <input matInput formControlName="certificatesOthers" appNoLeadingSpaces />
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-1">
    <div class="col-lg-12">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label>{{ "skillsAcquired" | translate}}</mat-label>
        <textarea matInput formControlName="skillsAcquired" appCharactersOnly appNoLeadingSpaces></textarea>
      </mat-form-field>
    </div>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="isItemBeingUpdated" class="mb-3 mt-3"></mat-progress-bar>

  <div class="row mt-2">
    <div *ngIf="successMessage" class="success-message">
      {{ "successMessageUpdateTraining" | translate }}
    </div>
    <div *ngIf="errorMessage" class="error-message">
      {{ "errorMessage" | translate }}
    </div>
  </div>
  <div class="row mt-3 mb-1">
    <div class="col-12 col-lg-12">
      <div class="d-flex justify-content-end">
        <div class="col-12 col-lg-auto">
          <div class="d-flex justify-content-end">
            <button mat-raised-button color="primary" class="text-white" (click)="updateTechnicalTraining()"
              [disabled]="isButtonDisabled">Update</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>